import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

export interface MedicaoAnteriorAntropometriaFormModel {
  data: string
  peso: string
  altura: string
  perimetroCefalico: string
  medicoes?: string
}

export const MEDICOES_ANTROPOMETRIA: Array<keyof HistoricoMedicaoModel> = [
  'valorPeso',
  'valorAltura',
  'valorPerimetroCefalico',
]
